// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__M3oSQ","itemTitle":"ClientEmergencyInfo_itemTitle__87KIM","itemText":"ClientEmergencyInfo_itemText__1jpWQ"};